<div
  *ngIf="ready && !visibility.isHidden"
  class="mw568 buttonContent tc"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
  dir="{{ dir$ | async }}"
>
  <a
    *ngIf="button.url; else buttonTemplate"
    class="button"
    [class.button-outline]="isOutlined"
    [href]="button.url"
    [ngStyle]="{
      'background-color': buttonBgColor,
      color: buttonTextColor
    }"
    target="_blank"
    rel="noopener noreferrer"
    (click)="onClick()"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </a>
  <ng-template #buttonTemplate>
    <button
      type="button"
      class="button"
      [class.button-outline]="isOutlined"
      [ngStyle]="{
        'background-color': buttonBgColor,
        color: buttonTextColor
      }"
      (click)="onClick()"
    >
      <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </button>
  </ng-template>
  <ng-template #buttonContent>
    <img
      *ngIf="iconResource && iconGravity === 'START'"
      class="buttonImg buttonImgStart"
      [src]="iconResource"
      [ngStyle]="{ width: iconWidth }"
      [alt]="imgAlt"
    />{{ buttonText
    }}<img
      *ngIf="iconResource && iconGravity === 'END'"
      class="buttonImg buttonImgEnd"
      [src]="iconResource"
      [ngStyle]="{ width: iconWidth }"
      [alt]="imgAlt"
    />
  </ng-template>
</div>
